import { supabase } from './supabaseClient';

export async function saveOffboarding({ company, currentUser, employeeId, action, payload, expectedExit, expectedSettlement }) {
  if (!['admin', 'company'].includes(currentUser?.role)) throw new Error('HR/Admin access is required for offboarding.');
  const { data, error } = await supabase.rpc('save_offboarding', {
    p_company_id: company.id, p_employee_id: employeeId, p_action: action, p_payload: payload,
    p_expected_exit: expectedExit || null, p_expected_settlement: expectedSettlement || null
  });
  if (error) {
    if (error.code === 'PGRST202' || /function.*does not exist|could not find.*save_offboarding/i.test(error.message || '')) {
      throw new Error('Offboarding database update is required. Run supabase/offboarding_atomic_update.sql, then retry. No changes were saved.');
    }
    throw new Error(error.message || 'Offboarding save failed. Refresh before retrying.');
  }
  if (!data?.config || data.employee?.id !== employeeId) throw new Error('Could not confirm the offboarding result. Refresh before retrying.');
  return data;
}
